import './previewFrame.scss'

interface PreviewFrameProps {
  url: string
}

export const PreviewFrame = ({ url }: PreviewFrameProps) => {
  return (
    <div className='preview-frame-wrapper'>
      <iframe src={url} title='Redirect' id='1c6110c5-1dc1-478d-8237-a9dac0daedc7' />
    </div>
  )
}
